import { Button, Col, Form, Input, Row, Space, theme, Table, message, Select, DatePicker } from 'antd';
import React, { useEffect, useState } from 'react';
import LoadingBase from '../../components/LoadingBase';
import '../../css/listbook-page.css';
import { inventory_report, warehouse_list } from '../../services/apis';
import { HeaderTableCus, LIST_UNITS, requiredItem } from '../../constants/constants';
import { filterOption } from '../../utils/funcHelper';
import { SearchOutlined } from '@ant-design/icons';

const InventoryReportPage = () => {
    const { token } = theme.useToken();
    const [form] = Form.useForm();
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [dataWarehouses, setDataWarehouses] = useState([]);
    const columns = [
        {
            title: 'STT',
            key: 'STT',
            width: 80,
            align: 'center',
            render: (text, record, index) => index + 1,
        },
        {
            title: 'Tên sản phẩm',
            dataIndex: 'product_name',
            key: 'product_name',
            width: '50%',
            align: 'center',
            render: (text, record, index) => <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }}>
                <a style={{ paddingLeft: 12 }}>{text}</a>
            </div>,
        },
        {
            title: 'Đơn vị tính',
            dataIndex: 'unit',
            key: 'unit',
            align: 'center',
            render: (text, record, index) => <span>{LIST_UNITS.find(item => item.value === text)?.label}</span>,
        },
        {
            title: 'Số lượng tồn',
            dataIndex: 'quantity',
            key: 'quantity',
            align: 'center',
            render: (text, record, index) => <span>{text}</span>,
        }
    ];
    const { RangePicker } = DatePicker;
    const formStyle = {
        maxWidth: 'none',
        background: 'white',
        borderRadius: token.borderRadiusLG,
        paddingLeft: 0,
        paddingRight: 0,
        marginBottom: 12,
    };


    const getDataInventory = async (showLoading) => {
        try {
            const params = {
                keyword: form.getFieldValue('name') ?? '',
                warehouse_id: form.getFieldValue('warehouse_id') ?? null,
            }
            if (showLoading) setLoading(true);
            const res = await inventory_report(params);
            if (showLoading) setLoading(false);
            if (res && res.status === 1) {
                setData([...res?.data?.products]);
            } else {
                message.error(res.msg || 'Có lỗi xảy ra, vui lòng thử lại');
                setData([]);
            }
        } catch (error) {
            setLoading(false);
            console.log('error', error);
        }


    }

    const getDataWarehouses = async () => {
        try {
            const params = {
                keyword: '',
                status: 'active',
                currentPage: 1,
                limit: 100,
            }
            const res = await warehouse_list(params);
            if (res && res.status === 1) {
                setDataWarehouses([...res?.data?.items?.map((item) => ({
                    ...item,
                    label: item.name,
                    value: item.id
                }))]);
            } else {
                setDataWarehouses([]);
            }
        } catch (error) {
            console.log('error', error);
        }


    }

    const onFinish = async (dataForm) => {
        getDataInventory(true);
    };

    useEffect(() => {
        setLoading(true);
        Promise.all([getDataWarehouses()]).finally(() => {
            setLoading(false);
        });
    }, [])

    return (
        <div className='container-content'>

            <Form form={form} name="advanced_search" style={formStyle} onFinish={onFinish}>
                <Row gutter={24}>
                    <Col span={8}>
                        <Form.Item
                            name={'name'}
                        >
                            <Input
                                placeholder={'Nhập tên'}
                                className='custom-input-antd'
                            />
                        </Form.Item>
                    </Col>

                    <Col span={4}>
                        <Form.Item
                            name={'warehouse_id'}
                            rules={requiredItem}
                        >
                            <Select
                                placeholder="Chọn kho"
                                options={dataWarehouses}
                                filterOption={filterOption}
                                showSearch
                                className='custom-input-antd'
                                style={{ width: '100%', height: 40 }}
                            />
                        </Form.Item>
                    </Col>
                    
                    <Col span={4}>
                        <Space size="small">
                            <Button
                                type="primary"
                                htmlType="submit"
                                icon={<SearchOutlined />}
                                className='custom-input-antd'
                            >
                                Xem tồn kho
                            </Button>
                        </Space>
                    </Col>
                </Row>
            </Form>
            <Table
                components={HeaderTableCus}
                columns={columns}
                dataSource={data}
                pagination={false}
                rowKey={(record) => record?.id}
                bordered
                rowClassName={() => 'custom-row'}
            />
            <LoadingBase loading={loading} />
        </div>
    )
}
export default React.memo(InventoryReportPage);